module.exports = __webpack_public_path__ + "static/media/TBI.77edc2f9.jpg";